import { render, staticRenderFns } from "./LabelsManagement.vue?vue&type=template&id=6d0969f9&"
import script from "./LabelsManagement.vue?vue&type=script&lang=js&"
export * from "./LabelsManagement.vue?vue&type=script&lang=js&"
import style0 from "./LabelsManagement.vue?vue&type=style&index=0&id=6d0969f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports